/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { UpdateStaffRoleMutationRequest, UpdateStaffRoleMutationResponse, UpdateStaffRolePathParams, UpdateStaffRole400, UpdateStaffRole401, UpdateStaffRole403, UpdateStaffRole404, UpdateStaffRole409, UpdateStaffRole500 } from "../../types/staffController/UpdateStaffRole.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getUpdateStaffRoleUrl(organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"]) {
  const res = { method: 'PUT', url: `/api/organizations/${organizationId}/staff/${staffId}/role` as const }
  return res
}

/**
 * @summary Update staff member role
 * {@link /api/organizations/:organizationId/staff/:staffId/role}
 */
export async function updateStaffRole(organizationId: UpdateStaffRolePathParams["organizationId"], staffId: UpdateStaffRolePathParams["staffId"], data: UpdateStaffRoleMutationRequest, config: Partial<RequestConfig<UpdateStaffRoleMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateStaffRoleMutationResponse, ResponseErrorConfig<UpdateStaffRole400 | UpdateStaffRole401 | UpdateStaffRole403 | UpdateStaffRole404 | UpdateStaffRole409 | UpdateStaffRole500>, UpdateStaffRoleMutationRequest>({ method : "PUT", url : getUpdateStaffRoleUrl(organizationId, staffId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}